import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@mui/material/Modal';
import { Box, Typography, IconButton, Backdrop } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GoogleMap from '~/components/GoogleMaps';
import MapContainer from '../MapContainer';
import GoogleMaps from '../GoogleMaps';

const DashboardDialogBox = ({ open, onClose, coordinates }) => {
    const handleClose = () => {
        onClose(); // Call the onClose function passed as props
    };

    const handleModalClick = (e) => {
        e.stopPropagation(); // Prevent event propagation when clicking inside the modal
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            onClick={handleModalClick} // Handle click event on the modal
        >
            <Box sx={{ 
                bgcolor: 'background.paper', 
                boxShadow: 24, 
                p: 1, 
                maxWidth: 1000, // Adjust the maximum width of the modal
                width: '100%', // Adjust the width of the modal
                maxHeight: '120vh', // Adjust the maximum height of the modal
                overflowY: 'auto', // Enable vertical scrolling if content overflows
                borderRadius: 2
            }}>
                <Typography variant="h6" id="modal-modal-title">
                    <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute' }}>
                        <CloseIcon />
                    </IconButton>
                </Typography>
                <Box>
                    <GoogleMaps coordinatesArray={coordinates} />
                </Box>
            </Box>
        </Modal>
    );
};

DashboardDialogBox.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    coordinates: PropTypes.arrayOf(
        PropTypes.shape({
            Latitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
            Longitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
            Location: PropTypes.string,
            plantTationCount: PropTypes.number
        })
    ).isRequired
};

export default DashboardDialogBox;
